<template>
  <div class="">
    <div class="panal mt-20">
      <div class="panal-header">Packages {{route}}</div>
      <div class="panal-body">
  
 <div class="mt-4">
    <b-card-group deck>
   
<b-overlay no-center show rounded="sm" class="col-4">
      <template #overlay>
        <b-icon
          icon="stopwatch"
          variant="info"
          scale="2"
          shift-v="8"
          shift-h="8"
          class="position-absolute"
          style="top: 0; right: 30"
        ></b-icon>
       <div class="text-center mt-5"><h2> Coming soon</h2></div>
      </template>
   

      <b-card bg-variant="secondary" text-variant="white" header="BY TRIP" class="text-center">
        <b-card-text>
          <h1>9 $ </h1>
        <small>PER USER / 1 Trip</small><br/><br/>
        Payment within Three days and then the reservation will be canceled
          <div class="text-center mt-3">
           <!-- <button class="nav-link btn btn-secondary " 
          id="v-pills-History-tab3" data-toggle="pill" href="#v-pills-History3" 
          role="tab" aria-controls="v-pills-History3"  > Enter
           
           </button> -->

            <button class="nav-link btn btn-secondary " id="tab3D" data-toggle="pill" href="#Tab3D" 
          > Enter
           
           </button>
    
           </div>
          
          
          
         </b-card-text>
      </b-card>
    </b-overlay>





     

         <b-card bg-variant="primary" text-variant="white" v-bind:header="pakage.Period" class="text-center">
        <b-card-text><h1>{{pakage.Price}} </h1>
        <small>PER USER / 3 MONTH</small><br/><br/>
        Payment within Three days and then the reservation will be canceled
         <div class="text-center mt-3">   
         <!-- <b-button class="nav-link btn btn-secondary  text-center " 
          id="v-pills-History-tab3" data-toggle="pill" href="#v-pills-History3" 
          role="tab" aria-controls="v-pills-History3"  @click="bookingDetails(pakage.Serial)" > Enter
           
           </b-button>  -->

           <b-button class="nav-link btn btn-secondary  text-center col-md-12 " 
        v-on:click="isHidden = !isHidden" @click="bookingDetails(pakage.Serial)" > Enter
           
           </b-button>
         
           
           </div>
        
        </b-card-text>
      </b-card>

     

<b-overlay no-center show rounded="sm" class="col-4">
      <template #overlay>
        <b-icon
          icon="stopwatch"
          variant="info"
          scale="2"
          shift-v="8"
          shift-h="8"
          class="position-absolute"
          style="top: 0; right: 30"
        ></b-icon>
       <div class="text-center mt-5"><h2> Coming soon</h2></div>
      </template>
   

       <b-card bg-variant="secondary" text-variant="white" header="YEAR PACHAGE" class="text-center" aria-hidden="true">
        <b-card-text>
<h1>30 $ </h1>
        <small>PER USER / 6 MONTH</small><br/><br/>
        Payment within Three days and then the reservation will be canceled
         <div class="mt-3"><b-button variant="light" size="sm" class="mt-2">Enter</b-button></div>


        </b-card-text>
      </b-card>
    </b-overlay>




    </b-card-group>
  </div>

      </div>
    </div>


<div  v-if="!isHidden" class="col-md-12">

 
  <PackagesDa v-bind:priceAndSeats="priceAndSeats" v-bind:currenUser="currenUser" v-bind:serial="serial"  />
  </div>

  </div>
</template>

<script>

import PackagesDa from "../../components/Transportations/PackagesDa.vue";
import TransportationService from '../../services/Transportation/Transportation.service';



export default {
   components: {
  PackagesDa
//   
  },
  name: "Packages",
  props:['route','pakage'],
  data() {

    return {
       display: false,
        isHidden: true,
    value : '',
    serial : '',
  
    priceAndSeats : ''
      
    }
  },

  mounted(){
 
  

  },
  methods:{
  
    bookingDetails(serial){
       this.$emit('clicked', serial),
       isHidden= true
    },
    SetValue(num){
      this.value = num
        TransportationService.GetAllRoutesPlans(num).then(response=>{
       this.pakage = response.data[0]
    })

    },
    GetSerial(serial){
      this.serial = serial
      TransportationService.GetPriceandAvilabelSeats(serial).then(response=>{
this.priceAndSeats = response.data
      })
    }
  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
}
}
</script>

<style scoped>
.b-overlay div{
  inset: 0px;
    opacity: 0.35 !important;
    backdrop-filter: blur(2px);

}
.btn-light {
    color: #fff;
    background-color: #295EB2;
    border-color: #1a54b0;
}
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  border: 1px solid #d4d4d4;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>